import api from "./index"

export async function getDoctors({ offset = 0, limit = 10, search = "" } = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      offset,
      limit,
      search,
    },
  }
  return api.get("/v1/doctors", config)
}

export async function createDoctor(data) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  return api.post("/v1/doctors", data, config)
}

export async function getDoctorById(id) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  return api.get(`/v1/doctors/${id}`, config)
}

export async function addDoctorMedia(doctorId, data) {
  if (!doctorId) {
    throw new Error("Doctor ID is required")
  }

  const formData = new FormData()

  // Add required fields
  formData.append("title", data.title)
  formData.append("description", data.description)
  formData.append("source", data.source)

  // Add optional fields if they exist
  if (data.file_link) {
    formData.append("file_link", data.file_link)
  }

  if (!data.file_link && data.media_file) {
    formData.append("media_file", data.media_file)
  }

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }

  try {
    return await api.post(`/v1/doctors/${doctorId}/media`, formData, config)
  } catch (error) {
    throw error.response?.data || error
  }
}

export async function deleteDoctor(id) {
  return api.delete(`/v1/doctors/${id}`)
}

export async function updateDoctor(id, data) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  return api.put(`/v1/doctors/${id}`, data, config)
}

export async function updateDoctorSchedule(doctorId, scheduleData) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  return api.put(`/v1/doctors/${doctorId}`, { schedule: scheduleData }, config)
}
